import React from "react";
import {Avatar, Badge, Button, ButtonGroup, Counter, Div, RichCell} from "@vkontakte/vkui";
import {Icon16Pen, Icon24DismissSubstract} from "@vkontakte/icons";
import BaseApi from "../api/BaseApi";
import * as constants from "../assets/constants";

class CartRow extends React.Component {
    state = {
        items: []
    }

    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }

    render() {
        const images_url = this.props.base_url.replace("/frontend/", '');
        const {item, index} = this.props
        return (
            <div>
                <RichCell multiline={true}
                          before={[<a data-fancybox={'galleryCart' + item.id}
                                      href={images_url + item.img}>
                              {<Avatar mode="image" style={{borderRadius: '5%'}} size={52}
                                       src={images_url + item.img}/>}</a>

                          ]}

                          caption={[
                              item.sclad_id && item.sclad_id !== -1 ? item.sclad_name :
                                  <span className="red">Под заказ</span>, <small
                                  style={{display: "block"}}><b>{item.series_code ? item.series_code : ''}</b></small>,
                              <small
                                  style={{display: "block"}}><b>{item.doc_name ? (item.doc_type ? item.doc_type : 'Документ') + ' ' + item.doc_name : ''}</b></small>,
                              <small className="red"
                                  style={{display: "block", color: "red"}}><b>{item.date_in ? 'Планируемая дата поступления на склад: ' + item.date_in : ''}</b></small>

                          ]}
                          afterCaption={[<div
                              style={{
                                  textAlign: "center",
                                  fontSize: "18px"
                              }}>{item.quantity + item.unit_name} </div>

                          ]}

                          after={
                              this.props.removeFromCart &&
                              <ButtonGroup mode="horizontal" gap="l" stretched align="right">
                                  <Button mode="secondary" size="l"
                                          onClick={() => this.props.removeFromCart(index)}>
                                      <Icon24DismissSubstract width={16}/>
                                  </Button>
                              </ButtonGroup>
                          }

                          className={'cart-row ' + (item.parent_product_id ? 'child' : '')}
                >
                    <span onClick={() => BaseApi.openProductSearch(item.name)}>{item.name}</span>

                </RichCell>
                {item.additional && Array.isArray(item.additional) &&
                    <div className="cart-row_additional-wrapper">
                        {item.additional.map(additional => additional.qnt > 0 &&
                            <Counter className="cart-row_additional" size="m" mode="secondary">
                                {additional.product ? additional.product.name : additional.name}
                                {additional.comment ? <b>[{additional.comment}]</b> : ''}&nbsp;{additional.type == "number" ? additional.qnt + ' м' : ''}
                            </Counter>)
                        }
                    </div>
                }
                <RichCell multiline={true}><ButtonGroup mode="horizontal" gap="l" stretched align="right">
                    {!(this.props.user && this.props.user.meta.settings && this.props.user.meta.settings.hide_prices == '1') &&
                        [<Button mode="primary" size="l" mode="secondary"
                                 after={item.discount != undefined && item.discount != 0 ? '-' + (item.discount.toFixed(2).replace('.00', '')) + '%' : ''}
                                 style={{textAlign: "center", minWidth: "120px"}}>
                            {item.discount != undefined && item.discount != 0 ?
                                <span style={{
                                    display: 'block',
                                    textDecoration: 'line-through',
                                    color: 'red',
                                    fontSize: 'smaller',
                                    fontWeight: 300
                                }}>
                                                                    {(item.price * 1).toFixed(2) + constants.currency_char}
                                                                    </span> : ''}
                            {(item.price * 1 - (item.discount != undefined && item.discount != 0 ? (item.price / 100 * item.discount) : 0)).toFixed(2) + constants.currency_char}
                        </Button>,
                            <Button mode="primary" size="l" mode="secondary"
                                    after={item.discount != undefined && item.discount != 0 ? '-' + (item.discount.toFixed(2).replace('.00', '')) + '%' : ''}
                                    style={{textAlign: "center", minWidth: "120px"}}>
                                {item.discount != undefined && item.discount != 0 ?
                                    <span style={{
                                        display: 'block',
                                        textDecoration: 'line-through',
                                        color: 'red',
                                        fontSize: 'smaller',
                                        fontWeight: 300
                                    }}>
                                                                    {(item.price * 1 * item.quantity).toFixed(2) + constants.currency_char}
                                                                    </span> : ''}
                                {((item.price * 1 - (item.discount != undefined && item.discount != 0 ? (item.price / 100 * item.discount) : 0)) * item.quantity).toFixed(2) + constants.currency_char}
                            </Button>]}
                    {this.props.showEditCart && <Button mode="primary" size="l"
                                                        onClick={() => this.props.showEditCart(index)}>
                        <Icon16Pen width={16}/>
                    </Button>}

                </ButtonGroup></RichCell>
            </div>
        );
    }
}

export default CartRow